// material
import ModernTable from '../../components/ModernTable';
import { TableInfoTitle } from './InfoTip';
import { MARKETING_INFO } from './marketingInfo';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Chip, alpha } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export default function BannerTable(props) {
  const theme = useTheme();
  const { data, machinesName } = props;

  const columns = [
    {
      title: 'Screen Saver Title',
      field: 'ssTitle',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ImageIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {rowData.ssTitle}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Image File Name',
      field: 'file',
      render: (rowData) => (
        <Chip
          icon={<InsertPhotoIcon sx={{ fontSize: 16 }} />}
          label={rowData.file}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.info.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Clicked',
      field: 'count',
      render: (rowData) => (
        <Chip
          icon={<TouchAppIcon sx={{ fontSize: 16 }} />}
          label={rowData.count}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Conversion',
      field: 'conv',
      render: (rowData) => (
        <Chip
          icon={<TrendingUpIcon sx={{ fontSize: 16 }} />}
          label={rowData.conv}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.warning.dark,
            },
          }}
        />
      ),
    },
  ];

  return (
    <ModernTable
      title={<TableInfoTitle title={'Banners: ' + machinesName} info={MARKETING_INFO.banners} />}
      columns={columns}
      data={data}
      options={{
        actionsColumnIndex: -1,
        pageSize: 5,
      }}
    />
  );
}
